import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { initializeApp } from "firebase/app";

// ✅ Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyAtpO96gGrJ6PHYQPAa1XlVEp7kjMGeA6A",
  authDomain: "faststyle-f63a1.firebaseapp.com",
  projectId: "faststyle-f63a1",
  storageBucket: "faststyle-f63a1.appspot.com",
  messagingSenderId: "200647176505",
  appId: "1:200647176505:web:645def56921617af94f8e8",
  measurementId: "G-D4R7EKKQ0X"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// ✅ Admin UID
const ADMIN_UID = "zlQcTgcludO7uxRS9b1tMsyci3k2";

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');

  const loginAdmin = async (email, password) => {
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      console.log("✅ Logged in:", user.email);
      console.log("🔐 UID:", user.uid);

      if (user.uid === ADMIN_UID) {
        setSuccess("🎉 Logged in as Admin!");
        // You can redirect to dashboard here:
        // window.location.href = "/admin-dashboard";
      } else {
        setError("❌ Access denied. You are not the admin.");
      }
    } catch (error) {
      console.error("❌ Login error:", error.message);
      setError("Login failed. Please check your email and password.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    loginAdmin(email, password);
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial", maxWidth: "400px", margin: "auto" }}>
      <h2>Admin Login</h2>

      {error && <p style={{ color: "red" }}>{error}</p>}
      {success && <p style={{ color: "green" }}>{success}</p>}

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Enter email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
        />
        <input
          type="password"
          placeholder="Enter password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
        />
        <button
          type="submit"
          disabled={loading}
          style={{ width: "100%", padding: "10px", cursor: "pointer" }}
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
